import {ArmorType, skillsToString} from '../enums';
import {ClassChooseItem} from './class-choose-item';

const AboutWeaponCategories: Record<string, string> = {
	Martial: 'Военное оружие',
	Simple: 'Простое оружие',
	LightMartial: 'Военное оружие со свойством Лёгкое',
	FencingMartial: 'Военное оружие со свойством Фехтовальное',
};

const Tools: Record<string, string> = {
	'thieves-tools': 'Инструменты вора',
};

export const formatClassChooseOption = (option: NonNullable<ClassChooseItem['options']>[number], key: ClassChooseItem['key']) => {
	switch (key) {
		case 'skill':
			return skillsToString(option);
		case 'armorProficiency':
			return option === 'Shields' ? ArmorType[option] : ArmorType[option] + ' броня';
		case 'weaponProficiency':
			return AboutWeaponCategories[option];
		case 'toolsProficiency':
			return Tools[option];
		default:
			return '';
	}
};
